export function createFeatureLockTranslator(tr?: (key: string) => string, language?: string) {
  return (key: string, fallbackDe: string): string => {
    if (tr) {
      const result = tr(key);
      if (result && result !== key) return result;
    }
    const isGerman = !language || language.toLowerCase().startsWith("de");
    return isGerman ? fallbackDe : key;
  };
}
